module.exports = {
	"_args": [
		[
			"websocket@1.0.22",
			"/home/circleci/repo"
		]
	],
	"_from": "websocket@1.0.22",
	"_id": "websocket@1.0.22",
	"_inBundle": false,
	"_integrity": "sha1-jDPjRJ+Hmq9RgpfJdEzr+BK549g=",
	"_location": "/websocket",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "websocket@1.0.22",
		"name": "websocket",
		"escapedName": "websocket",
		"rawSpec": "1.0.22",
		"saveSpec": null,
		"fetchSpec": "1.0.22"
	},
	"_requiredBy": [
		"/sendbird"
	],
	"_resolved": "https://registry.npmjs.org/websocket/-/websocket-1.0.22.tgz",
	"_spec": "1.0.22",
	"_where": "/home/circleci/repo",
	"author": {
		"name": "Brian McKelvey",
		"email": "brian@worlize.com",
		"url": "https://www.worlize.com/"
	},
	"browser": "lib/browser.js",
	"bugs": {
		"url": "https://github.com/theturtle32/WebSocket-Node/issues"
	},
	"config": {
		"verbose": false
	},
	"contributors": [
		{
			"name": "Iñaki Baz Castillo",
			"email": "ibc@aliax.net",
			"url": "http://dev.sipdoc.net"
		}
	],
	"dependencies": {
		"debug": "~2.2.0",
		"nan": "~2.0.5",
		"typedarray-to-buffer": "~3.0.3",
		"yaeti": "~0.0.4"
	},
	"description": "Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.",
	"devDependencies": {
		"buffer-equal": "^0.0.1",
		"faucet": "^0.0.1",
		"gulp": "git+https://github.com/gulpjs/gulp.git#4.0",
		"gulp-jshint": "^1.11.2",
		"jshint-stylish": "^1.0.2",
		"tape": "^4.0.1"
	},
	"directories": {
		"lib": "./lib"
	},
	"engines": {
		"node": ">=0.8.0"
	},
	"homepage": "https://github.com/theturtle32/WebSocket-Node",
	"keywords": [
		"websocket",
		"websockets",
		"socket",
		"networking",
		"comet",
		"push",
		"RFC-6455",
		"realtime",
		"server",
		"client"
	],
	"license": "Apache-2.0",
	"main": "index",
	"name": "websocket",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/theturtle32/WebSocket-Node.git"
	},
	"scripts": {
		"gulp": "gulp",
		"install": "(node-gyp rebuild 2> builderror.log) || (exit 0)",
		"test": "faucet test/unit"
	},
	"version": "1.0.22"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/websocket/package.json
 ** module id = 2954
 ** module chunks = 0
 **/